module.exports = __webpack_public_path__ + "static/media/lito_iter1.46e3e044.png";